import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ERoute } from '@core/routes';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { TelegramService } from '@infrastructure/telegram';

@Component({
  selector: 'app-navigation',
  imports: [RouterLink, RouterLinkActive, NgClass, TranslatePipe],
  templateUrl: './navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
  protected readonly ERoute = ERoute;

  readonly #telegram = inject(TelegramService);

  protected triggerHaptic(): void {
    this.#telegram.impactOccurred();
  }
}
